import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, AfterViewChecked } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subdivision } from '@ird/ng-common';

@Component({
  selector: 'app-region-selector',
  templateUrl: './region-selector.component.html',
  standalone: false,
})
export class RegionSelectorComponent implements OnChanges, AfterViewChecked {
  @Input() formGroup: FormGroup;
  @Input() countryCode: string;
  @Input() usStates: Subdivision[] = [];
  @Input() canadaStates: Subdivision[] = [];
  @Input() indiaStates: Subdivision[] = [];
  @Input() chinaStates: Subdivision[] = [];
  @Input() labelKey = 'SERVICEPOINT.CONTACT.REGION';
  @Output() stateChange = new EventEmitter<any>();

  normalizedCountryCode = '';
  private lastAppliedValue: string | null = null;
  private pendingValue: string | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['countryCode']) {
      const previousCountryCode = this.normalizedCountryCode;
      this.normalizedCountryCode = this.countryCode?.toLowerCase() || '';

      if (previousCountryCode !== this.normalizedCountryCode) {
        const currentValue = this.formGroup?.get('regionCode')?.value;
        if (currentValue) {
          this.pendingValue = currentValue;
        }
      }
    }
  }

  ngAfterViewChecked(): void {
    if (this.pendingValue && this.pendingValue !== this.lastAppliedValue) {
      const regionCodeControl = this.formGroup?.get('regionCode');
      if (regionCodeControl && regionCodeControl.value === this.pendingValue) {
        this.lastAppliedValue = this.pendingValue;
        this.pendingValue = null;
      } else if (regionCodeControl) {
        regionCodeControl.setValue(this.pendingValue, { emitEvent: false });
        this.lastAppliedValue = this.pendingValue;
        this.pendingValue = null;
      }
    }
  }

  onStateChange(event: any): void {
    this.stateChange.emit(event);
  }
}
